export default {
  slots: {
    identity: {
      label: 'Ausweisdokument',
      hint: 'Personalausweis, Reisepass oder Aufenthaltstitel, Vorder- und Rückseite. Auch die Ausweise deiner Gesellschafter gehören hierher.',
    },
    trade_registration: {
      label: 'Gewerbeanmeldung',
      hint: 'Die Gewerbeanmeldung, die du vom Gewerbeamt erhalten hast.',
    },
    commercial_register_extract: {
      label: 'Handelsregisterauszug',
      hint: 'Ein aktueller Auszug aus dem Handelsregister, falls dein Unternehmen dort eingetragen ist.',
    },
    bank_statement: {
      label: 'Kontoauszug',
      hint: 'Ein aktueller Kontoauszug deines Geschäftskontos, auf dem Kontoinhaber und IBAN zu sehen sind.',
    },
    shareholder_list: {
      label: 'Gesellschafterliste',
      hint: 'Die aktuelle Gesellschafterliste.',
      hint_gbr: 'Dein Gesellschaftsvertrag oder eine Liste aller Gesellschafter.',
    },
    tax_number: {
      label: 'Steuernummer oder USt-IdNr.',
      hint: 'Ein Schreiben des Finanzamts mit deiner Steuernummer oder die Bestätigung deiner USt-IdNr.',
    },
  },
  tags: {
    required: 'Pflicht',
    optional: 'Optional',
    missing: 'Fehlt',
  },
  kinds: {
    passport: 'Reisepass',
    driver_license: 'Führerschein',
    id_card: 'Personalausweis',
    residence_permit: 'Aufenthaltstitel',
  },
  holders: {
    owner: 'Inhaber',
    partner: 'Gesellschafter: {{name}}',
  },
  file: {
    with_back: 'Vorder- und Rückseite',
    uploaded_at: 'Hochgeladen am {{date}}',
    expires_at: 'Gültig bis {{date}}',
  },
  errors: {
    load: 'Die Dokumente konnten nicht geladen werden.',
  },
  empty: 'Noch keine Datei',
  buttons: {
    add: 'Datei hinzufügen',
    replace: 'Ersetzen',
    remove: 'Entfernen',
    retry: 'Erneut versuchen',
  },
  remove_confirm: {
    title: 'Diese Datei entfernen?',
    description: 'Für eine Datei, die du versehentlich hochgeladen hast.',
    ok: 'Entfernen',
    cancel: 'Abbrechen',
  },
  toasts: {
    remove_success: 'Datei entfernt',
    remove_error: 'Die Datei konnte nicht entfernt werden. Bitte versuche es erneut.',
  },
};
